export default __webpack_public_path__ + "static/media/background.b653d323.jpg";